import { Controller } from "stimulus";
import renderComponent from "javascript/renderComponent";

export default class extends Controller {
  connect() {
    renderComponent(this.element, "FuzzySearch", JSON.parse(this.data.get("props") || "{}"));
  }
}
